/**
 * Which document URLs are served by our own proxies, and therefore worth
 * fetching before they reach an <iframe>.
 *
 * A document link resolves to one of three things (see _build_download_response
 * in jupiter/gql/mutations/document.py):
 *
 *   1. the file-proxy tunnel  — `/api/file-proxy/stream/<uuid>`
 *   2. the document proxy     — `<base>/documents/<id>/file?token=<jwt>`
 *   3. a GCS presigned URL    — `https://storage.googleapis.com/...`
 *
 * The first two are ours and can fail with an HTTP error. An `<iframe src>`
 * renders that error instead of surfacing it, so the viewer opens showing an
 * error page rather than a document (#507). Fetching first turns the failure
 * into a toast.
 *
 * The third is cross-origin and cannot be fetched, so it must keep going
 * straight to the iframe.
 */
export function isProxyServedUrl(url: string): boolean {
  if (url.includes("/api/file-proxy/stream/")) return true;

  // The document proxy's base differs per environment (`/doc-proxy` in
  // production, `localhost:8012` locally), so match on the `token` query
  // parameter instead of the host. A GCS presigned URL never carries one — it
  // signs with `X-Goog-*` parameters — so this cannot catch case 3 by accident.
  return url.includes("/documents/") && /[?&]token=/.test(url);
}
